'use client'

import React, { useMemo } from 'react'

import { M_BUTTON_ARROW_ENUM, MButton } from '@/components'

import { THEME_COLORS_ENUM } from '../../../../types/colors'

import type { IProgramModule } from '../../../../types/module'

export interface IAModulesOrderButtonProps {
	baseUrl: string
	programId: number
	programPrice: number
	programPriceOld?: number
	selectedModules: IProgramModule[]
	color: THEME_COLORS_ENUM
	orderText?: string
	orderTextLong?: string
	orderTextSecondary?: string
	outline?: boolean
	className?: string
	link?: React.ElementType<React.AnchorHTMLAttributes<HTMLAnchorElement>>
}

export const AModulesOrderButton: React.FC<IAModulesOrderButtonProps> = ({
	baseUrl,
	programId,
	programPrice,
	programPriceOld,
	selectedModules,
	color,
	orderText = 'Objednať',
	orderTextLong = 'Objednať program',
	orderTextSecondary = 'Pridané extra moduly v hodnote',
	link
}) => {
	const orderUrl = useMemo(() => {
		const moduleIds = selectedModules.map(m => m.id).join(',')
		const url = `${baseUrl}?type=annual-program&id=${programId}`
		return moduleIds ? `${url}&extraModules=${moduleIds}` : url
	}, [baseUrl, programId, selectedModules])

	const totalModulesPrice = useMemo(() => {
		return selectedModules.reduce((acc, module) => acc + module.price, 0)
	}, [selectedModules])

	const hasPriceOld = programPriceOld != null && programPriceOld > 0

	const priceText = useMemo(() => {
		const displayText = hasPriceOld ? orderText : orderTextLong

		return (
			<span>
				{displayText} ({programPrice} €
				{hasPriceOld && (
					<span style={{ textDecoration: 'line-through' }}>{programPriceOld} €</span>
				)}
				)
			</span>
		)
	}, [programPrice, programPriceOld, hasPriceOld, orderText, orderTextLong])

	return (
		<MButton
			key='modules'
			href={orderUrl}
			linkComponent={link}
			color={color}
			icon={M_BUTTON_ARROW_ENUM.RIGHT}
		>
			<span>
				{priceText}

				{selectedModules.length > 0 && (
					<span className='second-line-text'>
						{orderTextSecondary} {totalModulesPrice} €
					</span>
				)}
			</span>
		</MButton>
	)
}

AModulesOrderButton.displayName = 'AModulesOrderButton'
